
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: true
        },
        value: {
            type: [String, Number],
            default: ''
        },
        options: {
            type: [Array, Object],
            default: () => []
        }
    },
    computed: {
        newOptions () {
            if (Array.isArray(this.options)) {
                return this.options.map(item => ({
                    label: item.label,
                    value: item.value
                }))
            } else {
                return Object.entries(this.options).map(([key, value]) => ({
                    label: value,
                    value: key
                }))
            }
        }
    },
    methods: {
        handleSelect (optionValue) {
            this.$emit('input', optionValue)
            this.$emit('change', optionValue)
        }
    }
}
